export const bingoGamesWatcher = {
  initial: 'idle',
  on: {
    WATCH_BINGO_GAMES_TIMER: 'bingoGamesWatcher.watchingBingoGamesTimer',
  },
  states: {
    idle: {},
    watchingBingoGamesTimer: {
      invoke: { src: 'watchBingoGamesTimer' },
    },
  },
};
